export const SHOW_NULL_VALUES = "NULL values";
export const NULL_VALUES = "NULL values";
export const DATE_RANGE = "dateRange";
export const ALL = "All";

export const TYPE_STRING = "string";

export const METRIC_CHANNEL_OBJ = "channel_objective";
export const METRIC_LIFETIME_RCH = "lifetime_reach";
export const METRIC_LIFETIME_FRQ = "lifetime_frequency";

export const PLAN_TABLE_PARTIAL = "Partial Collapse";
export const PLAN_TABLE_COLLAPSED = "Collapsed";
export const PLAN_TABLE_EXPANDED = "Expanded";

export const planListDefaultStep = 10;
export const planListTableSteps = [10, 25, 50];
export const planCollapseStateOptions = [PLAN_TABLE_PARTIAL, PLAN_TABLE_COLLAPSED, PLAN_TABLE_EXPANDED];
export const searchFilter = "search";

export const levels = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
];

export const CALCULATE_BY = {
  BUDGET: "budget",
  KPI_GOAL: "kpiGoal",
} as const;

export const REASONABLE_PROJECT_LIST_STEP = 200 as const;
export const KPIS_MAX = 4;

export type CalculateBy = (typeof CALCULATE_BY)[keyof typeof CALCULATE_BY];

export const PLAN_MODULE = "plan" as const;
export const PLAN_EXPLORE_MODULE = "planExplore" as const;
export const PLAN_DUAL_MODULE = "planDual" as const;
export const EXPLORE_MODULE = "explore" as const;

export const DATA_MODE = {
  PROJECT: "project",
  EXPLORE: "explore",
  DUAL: "dual",
} as const;
export type DataMode = (typeof DATA_MODE)[keyof typeof DATA_MODE];
export const DEFAULT_DATA_MODES: DataMode[] = [DATA_MODE.PROJECT, DATA_MODE.EXPLORE];
export const METRIC_DISTRIBUTION = "metric" as const;
export const TIME_DISTRIBUTION = "time" as const;
export const DEFAULT_REPORT_DATA_TYPE = "Arm Candy Media Data" as const;
export const TABLE_GROUP_STANDARD = "standard" as const;
export const TABLE_SUBGROUP_ADVERTISER_METRICS = "advertiser" as const;

export const advertiserColumns = [
  { key: "advertiser_name", label: "Advertiser" },
  { key: "industry", label: "Industry" },
  { key: "sub_industry", label: "Sub-Industry" },
  { key: "profile_type", label: "Profile Type" },
  { key: "estimated_audience_size", label: "Estimated Audience Size" },
  { key: "estimated_time_to_conversion", label: "Estimated Time To Conversion" },
  { key: "average_order_value", label: "Average Order Value" },
  { key: "brand_recognition", label: "Brand Recognition" },
  { key: "pixeling_experience", label: "Pixeling Experience" },
  { key: "website_conversion_experience", label: "Website Conversion Experience" },
  { key: "date_of_rating", label: "Date of Rating" },
  { key: "url", label: "URL" },
] as const;

export const geoColumns = [
  { key: "state", label: "State" },
  { key: "dma", label: "DMA" },
  { key: "city", label: "City" },
  { key: "zip", label: "ZIP" },
] as const;

export const PRIVATE_TEMPLATE: string = "private" as const;
export const PUBLIC_TEMPLATE: string = "public" as const;

export const STATE_TO_ABBR: Record<string, string> = {
  alabama: "AL",
  alaska: "AK",
  arizona: "AZ",
  arkansas: "AR",
  california: "CA",
  colorado: "CO",
  connecticut: "CT",
  delaware: "DE",
  "district of columbia": "DC",
  florida: "FL",
  georgia: "GA",
  hawaii: "HI",
  idaho: "ID",
  illinois: "IL",
  indiana: "IN",
  iowa: "IA",
  kansas: "KS",
  kentucky: "KY",
  louisiana: "LA",
  maine: "ME",
  maryland: "MD",
  massachusetts: "MA",
  michigan: "MI",
  minnesota: "MN",
  mississippi: "MS",
  missouri: "MO",
  montana: "MT",
  nebraska: "NE",
  nevada: "NV",
  "new hampshire": "NH",
  "new jersey": "NJ",
  "new mexico": "NM",
  "new york": "NY",
  "north carolina": "NC",
  "north dakota": "ND",
  ohio: "OH",
  oklahoma: "OK",
  oregon: "OR",
  pennsylvania: "PA",
  "rhode island": "RI",
  "south carolina": "SC",
  "south dakota": "SD",
  tennessee: "TN",
  texas: "TX",
  utah: "UT",
  vermont: "VT",
  virginia: "VA",
  washington: "WA",
  "west virginia": "WV",
  wisconsin: "WI",
  wyoming: "WY",
};

export const chartMetrics: Record<string, string> = {
  acquisitions: "acquisitions",
  app_events: "app_events",
  app_installs: "app_installs",
  bookings: "bookings",
  clicks: "clicks",
  completed_views: "completed_views",
  cpa: "cpa",
  cpae: "cpae",
  cpb: "cpb",
  cpc: "cpc",
  cpcv: "cpcv",
  cpe: "cpe",
  cper: "cper",
  cpi: "cpi",
  cpl: "cpl",
  cpia: "cpia",
  cpla: "cpla",
  cplc: "cplc",
  cplv: "cplv",
  cpm: "cpm",
  cpp: "cpp",
  cppl: "cppl",
  cps: "cps",
  cpsa: "cpsa",
  cpsv: "cpsv",
  ctr: "ctr",
  engagements: "engagements",
  event_response: "event_response",
  impressions: "impressions",
  intent_actions: "intent_actions",
  landing_page_views: "landing_page_views",
  leads: "leads",
  link_clicks: "link_clicks",
  local_action: "local_action",
  page_likes: "page_likes",
  purchase_value: "purchase_value",
  purchases: "purchases",
  roas: "roas",
  site_action: "site_action",
  store_visits: "store_visits",
  submission_entries: "submission_entries",
  vcr: "vcr",
  video_views: "video_views",
};

export const weightedMap: Record<string, { num: string; denom: string; multiplier?: number }> = {
  cpm: { num: "channel_budget", denom: "impressions", multiplier: 1000 },
  roas: { num: "purchase_value", denom: "channel_budget" },
  cpb: { num: "channel_budget", denom: "bookings" },
  cpc: { num: "channel_budget", denom: "clicks" },
  cpcv: { num: "channel_budget", denom: "video_views" },
  cpe: { num: "channel_budget", denom: "engagements" },
  cper: { num: "channel_budget", denom: "event_response" },
  cpa: { num: "channel_budget", denom: "acquisitions" },
  cpae: { num: "channel_budget", denom: "app_events" },
  cpi: { num: "channel_budget", denom: "app_installs" },
  cpia: { num: "channel_budget", denom: "intent_actions" },
  cpl: { num: "channel_budget", denom: "leads" },
  cpla: { num: "channel_budget", denom: "local_action" },
  cplc: { num: "channel_budget", denom: "link_clicks" },
  cplv: { num: "channel_budget", denom: "landing_page_views" },
  cpp: { num: "channel_budget", denom: "purchases" },
  cppl: { num: "channel_budget", denom: "page_likes" },
  cps: { num: "channel_budget", denom: "submission_entries" },
  cpsa: { num: "channel_budget", denom: "site_action" },
  cpsv: { num: "channel_budget", denom: "store_visits" },
} as const;

export const qaTeam = ["ivan.miropolskiy@steppechange.com", "anastasiya.sakhibova@steppechange.com"] as const;
